import {observer} from 'mobx-react';
import {TimeInput, FormError} from 'shared/components';
import LabelHelper from 'shared/components/LabelHelper';
import {ActionLinks} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import AvailabilityWindowsTableState from '../../../state/AvailabilityWindowsTableState';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const AvailabilityWindowRow = observer(({window, uiState, showDayLabel, dayKey, canRemove}) => {
  const customLinks = [
    {
      order: 0,
      text: 'recruiting.interview_schedules.edit.Add a time',
      action: () => uiState.addAvailabilityWindow(window.dayOfWeek),
      translate: true
    }
  ];

  if (canRemove) {
    customLinks.push({
      order: 1,
      text: 'recruiting.interview_schedules.edit.Remove',
      action: () => uiState.removeAvailabilityWindow(window),
      translate: true
    });
  }

  return (
    <div className='flex align-items-middle my1'>
      <div className='col-2'>
        {showDayLabel && <FormattedMessage id={`recruiting.interview_schedules.edit.${dayKey}`}/>}
      </div>
      <div className='mr2 col-3'>
        <TimeInput
          initialValue={window.startTime}
          onFormat={({value, error}) => !error && uiState.updateAvailabilityWindow(window, {startTime: value})}
        />
      </div>
      <div className='mr2 col-3'>
        <TimeInput
          initialValue={window.endTime}
          lowerBound={window.startTime}
          onFormat={({value, error}) => !error && uiState.updateAvailabilityWindow(window, {endTime: value})}
        />
      </div>
      <ActionLinks
        model={window}
        customLinks={customLinks}
        onlyShowCustomLinks
      />
    </div>
  );
});

const AvailabilityWindowsTable = observer(({uiState, errorMessage}) => {
  const {sortedWindows} = uiState;

  return (
    <div>
      <LabelHelper
        label={t('recruiting.interview_schedules.edit.Weekly Availability')}
        tooltip={{paragraphs: [t('recruiting.interview_schedules.edit.tooltips.weekly_availability')]}}
      />
      {DAYS.map((key, dayIndex) => {
        const rowsForDay = sortedWindows.filter(window => window.dayOfWeek === dayIndex);
        return rowsForDay.map((window, index) => (
          <AvailabilityWindowRow
            key={window.id}
            window={window}
            uiState={uiState}
            showDayLabel={index === 0}
            dayKey={key}
            canRemove={rowsForDay.length > 1}
          />
        ));
      })}
      <FormError message={errorMessage}/>
    </div>
  );
});

export default withState(AvailabilityWindowsTable, AvailabilityWindowsTableState);
